module.exports = __webpack_public_path__ + "img/prev-sub.53d4603d.svg";